import React from "react";

// Coque du Centre de contrôle conformité affichée instantanément au clic sur
// l'icône GI/LAB, le temps que le code de la fenêtre arrive (chargé à la
// demande). Mêmes dimensions que GiLabOverlay pour éviter tout saut.
const Bloc = ({ className = "" }) => <div className={`bg-slate-100 rounded animate-pulse ${className}`} />;

export default function GiLabOverlaySkeleton({ clientNom = "", onClose }) {
  return (
    <div className="fixed inset-0 z-[20000] flex items-center justify-center bg-black/40 backdrop-blur-sm" onClick={onClose}>
      <div
        className="bg-white rounded-2xl shadow-2xl w-full mx-6 overflow-hidden flex flex-col"
        style={{ maxWidth: "980px", height: "90vh" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-3 px-5 py-4 border-b border-slate-100 shrink-0">
          <Bloc className="w-11 h-11 !rounded-2xl shrink-0" />
          <div className="min-w-0 flex-1">
            <h3 className="text-sm font-bold text-slate-900 leading-tight m-0 truncate">
              Centre de contrôle conformité — {clientNom.toUpperCase()}
            </h3>
            <Bloc className="h-3 w-40 mt-2" />
          </div>
        </div>
        <div className="px-5 py-3 border-b border-slate-100 shrink-0">
          <Bloc className="h-2 w-full !rounded-full" />
          <Bloc className="h-3 w-32 mt-2" />
        </div>
        <div className="flex-1 px-6 py-5 space-y-3 overflow-hidden">
          {[0, 1, 2, 3].map((i) => (
            <div key={i} className="relative pl-12">
              <Bloc className="absolute left-0 top-1 w-9 h-9 !rounded-full" />
              <div className="border border-slate-100 rounded-xl p-4 space-y-2">
                <Bloc className="h-4 w-1/3" />
                <Bloc className="h-3 w-2/3" />
                <Bloc className="h-3 w-1/2" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
